import { type Translate } from 'react-admin';

import { IEmployeesCheckUploadXLSError } from '@/types';
import { htmlDecode } from '@/utils';

export function formatEmployeesErrors(
  errors: IEmployeesCheckUploadXLSError[],
  translate: Translate,
): string {
  return errors
    .map(({ message, raw }: IEmployeesCheckUploadXLSError): string => {
      if (!message.includes('employee.errors')) {
        return htmlDecode(message);
      }

      return raw !== 0
        ? translate(`resources.${message}`, { field: raw })
        : translate(`resources.${message}`);
    })
    .join(' ');
}
